import { HorizontalContainer } from '@american-autonomy/ag-ui';

import WarningIcon from 'components/icons/WarningIcon';
import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MapError: FunctionComponent<Props> = ({ className = '', error, testId = TEST_ID }: Props) => {
    const { message } = error;

    return (
        <HorizontalContainer className={`${styles.errorContainer} ${className}`} testId={testId}>
            <WarningIcon />

            <BodyText className={styles.bodyText} text={message} />
        </HorizontalContainer>
    );
};

export default MapError;
